import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon } from 'lucide-react';
export function BonusCover() {
  return <section className="w-full bg-gradient-to-b from-[#0a0e27] to-[#141b3d] py-16 md:py-24 relative overflow-hidden" data-id="element-54">
      {/* Subtle background texture overlay (simulated with CSS) */}
      <div className="absolute inset-0 opacity-[0.03] bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-white via-transparent to-transparent pointer-events-none" data-id="element-55"></div>

      <div className="max-w-lg mx-auto px-4 relative z-10 flex flex-col items-center text-center" data-id="element-56">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="w-full flex flex-col items-center" data-id="element-57">
          {/* Top Label */}
          <div className="inline-flex items-center gap-2 text-[#C4A962] text-sm font-medium uppercase tracking-widest mb-10" data-id="element-58">
            <SparklesIcon className="w-4 h-4" data-id="element-59" />
            <span data-id="element-60">Bonus Exclusivo</span>
            <SparklesIcon className="w-4 h-4" data-id="element-61" />
          </div>

          {/* Book Cover Showcase */}
          <div className="relative w-full max-w-[280px] sm:max-w-xs md:max-w-sm mx-auto mb-10 perspective-[1000px]" data-id="element-62">
            {/* Ambient Glow Behind Book */}
            <div className="absolute inset-0 bg-[#C4A962]/20 blur-[40px] rounded-full transform scale-110 translate-y-4" data-id="element-63"></div>

            {/* The Book Image with 3D Tilt */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.9,
            rotateY: 0
          }} whileInView={{
            opacity: 1,
            scale: 1,
            rotateY: -8,
            rotateX: 4
          }} viewport={{
            once: true
          }} transition={{
            duration: 1,
            delay: 0.2,
            ease: 'easeOut'
          }} className="relative z-10 rounded-lg overflow-hidden shadow-[0_20px_50px_rgba(196,169,98,0.15)] ring-1 ring-white/10" style={{
            transformStyle: 'preserve-3d'
          }} data-id="element-64">
              {/* Book Spine Highlight (Left Edge) */}
              <div className="absolute left-0 top-0 bottom-0 w-1 bg-gradient-to-r from-white/20 to-transparent z-20 mix-blend-overlay" data-id="element-65"></div>

              <img src="https://cdn.magicpatterns.com/uploads/dmov2dHwHPXrk14HDCjbaE/heylloyd-image-1774065704953.png" alt="Ritual Nocturno 3-Min Checklist de Drenaje" className="w-full h-auto object-cover aspect-[4/5] block" data-id="element-66" />
            </motion.div>
          </div>

          {/* Gift Badge + Price */}
          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.5
        }} className="mb-6" data-id="element-67">
            <p className="text-[#C4A962] text-sm font-medium uppercase tracking-wider mb-2" data-id="element-68">
              Gratis con tu compra
            </p>
            <div className="flex items-center justify-center gap-3" data-id="element-69">
              <span className="text-white/40 line-through text-xl" data-id="element-70">$47.00</span>
              <span className="text-[#C4A962] font-bold text-2xl" data-id="element-71">GRATIS</span>
            </div>
          </motion.div>

          {/* Tagline */}
          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.7
        }} className="text-[#F5F0E8] text-lg md:text-xl italic font-light mb-8" data-id="element-72">
            Activa tu drenaje mientras duermes
          </motion.p>

          {/* Bottom Divider */}
          <motion.div initial={{
          opacity: 0,
          scaleX: 0
        }} whileInView={{
          opacity: 1,
          scaleX: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.8
        }} className="h-px w-full max-w-[200px] bg-gradient-to-r from-transparent via-[#C4A962]/40 to-transparent" data-id="element-73"></motion.div>
        </motion.div>
      </div>
    </section>;
}